export default __webpack_public_path__ + "static/media/deauville15.9d9ae3bf.jpg";